// Левое меню ERP — единый источник правды (решение Анны 03.11.2026).
// Каждый пункт: куда ведёт, кому виден, короткое пояснение «зачем сюда идти» и слова для поиска.
// Порядок «Каждый день» по ролям собран по истории рейсов за 04.10–03.11.2026 (545 рейсов, 3 100 действий
// людей): логисты почти всё делают в «Рейсах» и карточке рейса — назначают исполнителя, ставку, сроки
// оплаты, НДС, отправляют кандидата и доверенность в TMS. Остальное — реже, поэтому собрано в группы.
// Права проверяются здесь же, как в маршрутах router/index.js: меню не показывает то, что не откроется.

export const ITEMS = {
  home: {
    name: 'Главная', path: '/', exact: true, icon: 'fa-house',
    hint: 'Пульс компании: что горит и куда смотреть',
    keywords: 'старт пульс компания обзор',
  },
  summary: {
    name: 'Сводка логиста', path: '/summary', icon: 'fa-gauge-high', badge: 'summary',
    hint: 'Рейсы, которые требуют внимания прямо сейчас',
    keywords: 'светофор рабочий стол мои рейсы срочно критичные глобус',
    access: { nonGuestOnly: true },
  },
  trips: {
    name: 'Рейсы', path: '/trips', icon: 'fa-truck',
    hint: 'Все заявки: исполнитель, ставка, оплата, TMS',
    keywords: 'заявки рейс карточка исполнитель ставка ндс доверенность кандидат tms статус',
    access: { nonGuestOnly: true },
  },
  executors: {
    name: 'Исполнители', path: '/executors', icon: 'fa-id-card',
    hint: 'Перевозчики, водители и машины для рейса',
    keywords: 'перевозчик водитель машина тягач прицеп проверка безопасность',
    access: { nonGuestOnly: true },
  },
  downtimes: {
    name: 'Простои', path: '/downtimes', icon: 'fa-hourglass-half',
    hint: 'Где стоит машина и акты простоя',
    keywords: 'простой акт ожидание погрузка выгрузка',
    access: { nonGuestOnly: true },
  },
  claims: {
    name: 'Претензионная работа', path: '/claims', icon: 'fa-scale-balanced', badge: 'claims',
    hint: 'Срывы, отказы и простои — деньги, которые возвращаем',
    keywords: 'претензия срыв отказ штраф простой акт юрист',
    access: { nonGuestOnly: true },
  },
  notifications: {
    name: 'Уведомления', path: '/notifications', icon: 'fa-bell', badge: 'unread',
    hint: 'Сообщения системы и коллег',
    keywords: 'сообщения оповещения колокольчик',
    access: { nonGuestOnly: true },
  },
  knowledge: {
    name: 'База знаний', path: '/knowledge', icon: 'fa-book-open',
    hint: 'Как работает система и что нового',
    keywords: 'помощь инструкция вопрос что нового справка',
    access: { nonGuestOnly: true },
  },

  // Торги и распределение
  bidding: {
    name: 'Торги', path: '/pure-bidding', icon: 'fa-trophy',
    hint: 'Заявки с площадок заказчиков и ставки бота',
    keywords: 'торги аукцион ставка бот площадка заказчик',
    access: { nonGuestOnly: true },
  },
  distribution: {
    name: 'Распределение', path: '/distribution', icon: 'fa-sliders',
    hint: 'Кому из логистов какой рейс и по какой цене',
    keywords: 'распределение очередь аванс закрытие',
    access: { nonGuestOnly: true },
  },
  calculator: {
    name: 'Калькулятор', path: '/commercial-calculator', icon: 'fa-calculator',
    hint: 'Сколько заработаем на рейсе',
    keywords: 'калькулятор маржа прибыль расчёт автолидер',
    access: { nonGuestOnly: true },
  },
  approvals: {
    name: 'Согласования', path: '/admin/approvals', icon: 'fa-circle-check',
    hint: 'Ставки, которые ждут решения руководителя',
    keywords: 'согласование одобрить ставка руководитель',
    access: { permission: 'distribution.approvals' },
  },
  routeCost: {
    name: 'Стоимость маршрута', path: '/ati-route-cost', icon: 'fa-route',
    hint: 'Рыночная цена направления по ATI',
    keywords: 'ati ати стоимость маршрут направление рынок',
    access: { adminOnly: true },
  },

  // Документы и деньги
  registry: {
    name: 'Реестры', path: '/registry', icon: 'fa-file-invoice',
    hint: 'Комплекты документов и сроки сдачи заказчику',
    keywords: 'реестр документы оригиналы счёт сдача эфес',
    access: { registry: true },
  },
  finance: {
    name: 'Финансы', path: '/finance', icon: 'fa-coins',
    hint: 'Показатели группы логистов в деньгах',
    keywords: 'финансы комиссия маржа деньги показатели группы',
    access: { dynamic: 'finance' },
  },

  // Справочники
  cars: { name: 'Машины', path: '/cars', icon: 'fa-truck-front', hint: 'Тягачи и их проверка', keywords: 'машина тягач госномер', access: { nonGuestOnly: true } },
  trailers: { name: 'Прицепы', path: '/trailers', icon: 'fa-trailer', hint: 'Прицепы и полуприцепы', keywords: 'прицеп полуприцеп', access: { nonGuestOnly: true } },
  drivers: { name: 'Водители', path: '/drivers', icon: 'fa-user', hint: 'Водители и их документы', keywords: 'водитель паспорт права', access: { nonGuestOnly: true } },
  companies: { name: 'Компании', path: '/companies', icon: 'fa-building', hint: 'Перевозчики: ИНН, реквизиты, проверка', keywords: 'компания перевозчик инн реквизиты ип ооо', access: { nonGuestOnly: true } },
  managers: { name: 'Менеджеры перевозчиков', path: '/managers', icon: 'fa-address-book', hint: 'Контакты на стороне перевозчика', keywords: 'менеджер контакт перевозчик телефон', access: { nonGuestOnly: true } },
  customers: { name: 'Заказчики', path: '/customers', icon: 'fa-handshake', hint: 'Заказчики, матрицы ставок, чёрные списки', keywords: 'заказчик клиент матрица чёрный список', access: { nonGuestOnly: true } },
  topClients: { name: 'Топ-клиенты', path: '/topClients', icon: 'fa-star', hint: 'Ключевые клиенты и их условия', keywords: 'топ клиенты важные', access: { nonGuestOnly: true } },

  // Аналитика и ассистент
  statGeneral: { name: 'Общая статистика', path: '/statistics/general', icon: 'fa-chart-line', hint: 'Рейсы, направления, логисты, бот', keywords: 'статистика отчёт аналитика', access: { permission: 'statistics.general' } },
  statDowntimes: { name: 'Статистика простоев', path: '/statistics/downtimes', icon: 'fa-chart-column', hint: 'Сколько и где стоят машины', keywords: 'статистика простои', access: { permission: 'statistics.general' } },
  statPersonal: { name: 'Моя статистика', path: '/statistics/personal', icon: 'fa-user-check', hint: 'Личные результаты', keywords: 'персональная моя статистика результат', access: { permission: 'statistics.personal' } },
  statTm: { name: 'ТрансМенеджер', path: '/statistics/transmanager', icon: 'fa-table', hint: 'Отчёты по данным ТрансМенеджера', keywords: 'трансменеджер тм отчёт конструктор', access: { permission: 'statistics.transmanager' } },
  ai: { name: 'AI-ассистент', path: '/ai-assistant', icon: 'fa-robot', hint: 'Спросите своими словами — посчитает и найдёт', keywords: 'ии ai ассистент вопрос чат', access: { permission: 'ai_agent.use' } },
  aiReports: { name: 'Отчёты ассистента', path: '/ai-reports', icon: 'fa-file-lines', hint: 'Готовые отчёты AI-ассистента', keywords: 'отчёты ассистент ai', access: { permission: 'ai_agent.use' } },
  aiKnowledge: { name: 'Документы ассистента', path: '/ai-knowledge', icon: 'fa-folder-open', hint: 'Что ассистент знает о компании', keywords: 'документы ассистент знания', access: { permission: 'ai_agent.use' } },

  // Ставки и настройки
  rules: { name: 'Пульт правил', path: '/admin/rules', icon: 'fa-toggle-on', hint: 'Сроки и пороги, по которым работает система', keywords: 'пульт правила пороги сроки настройки', access: { permission: 'rules.view' } },
  tripRates: { name: 'Ставки рейсов', path: '/ati-route', icon: 'fa-tags', hint: 'Ставки по направлениям', keywords: 'ставки направления маршруты ati', access: { permission: 'ati.route.manage' } },
  baseRates: { name: 'Ставки распределения', path: '/memory/base-rates', icon: 'fa-scale-unbalanced', hint: 'Базовые ставки для распределения', keywords: 'базовые ставки распределение', access: { permission: 'memory.base_rates' } },
  tradingRates: { name: 'Торговые ставки', path: '/memory/trading-rates', icon: 'fa-chart-area', hint: 'Ставки, которые бот ставит на торгах', keywords: 'торговые ставки бот торги', access: { permission: 'memory.trading_rates.read' } },
  calcSettings: { name: 'Настройки калькулятора', path: '/admin/commercial-calculator-settings', icon: 'fa-sliders', hint: 'Формула и версии калькулятора', keywords: 'калькулятор настройки формула версии', access: { permission: 'calculator.settings.read' } },
  advanceBudgets: { name: 'Бюджеты авансирования', path: '/settings/advance-budgets', icon: 'fa-wallet', hint: 'Лимиты авансов перевозчикам', keywords: 'аванс бюджет лимит', access: { permissionAny: ['distribution.admin', 'advance.admin'] } },
  registrySettings: { name: 'Настройки реестров', path: '/registry/settings', icon: 'fa-file-circle-check', hint: 'Правила сборки реестров', keywords: 'реестры настройки', access: { registry: true } },
  aiSettings: { name: 'Настройки ассистента', path: '/ai-settings', icon: 'fa-gear', hint: 'Как отвечает AI-ассистент', keywords: 'ai настройки ассистент', access: { permission: 'ai_agent.settings' } },

  // Администрирование
  users: { name: 'Пользователи и роли', path: '/users/user-routing', icon: 'fa-users', hint: 'Сотрудники, роли и права', keywords: 'пользователи роли права доступ сотрудники', access: { adminOnly: true } },
  tmsLog: { name: 'Журнал TMS', path: '/admin/tms-action-log', icon: 'fa-list-check', hint: 'Что система отправляла в TMS и что ответила', keywords: 'журнал tms лог ошибки', access: { permission: 'tms.action_log' } },
  atiPublish: { name: 'Публикация в ATI', path: '/admin/distributor-routing', icon: 'fa-bullhorn', hint: 'Какие грузы и куда выставляются на ATI', keywords: 'ati публикация выставление грузы', access: { adminOnly: true } },
  priceCheck: { name: 'Цены из ATI', path: '/ati-price-check', icon: 'fa-magnifying-glass-dollar', hint: 'Проверка рыночных цен по ATI', keywords: 'ati цены проверка бюджет', access: { adminOnly: true } },
  security: { name: 'Безопасность', path: '/admin/security-options', icon: 'fa-shield-halved', hint: 'Статусы проверки исполнителей', keywords: 'безопасность проверка статусы', access: { adminOnly: true } },
  tmsTemplates: { name: 'Шаблоны TMS', path: '/admin/tms-template', icon: 'fa-clone', hint: 'Шаблоны данных для TMS', keywords: 'шаблоны tms кандидат', access: { adminOnly: true } },
  orphans: { name: 'Чистка записей', path: '/admin/orphan-cleanup', icon: 'fa-broom', hint: 'Записи без привязки к рейсам', keywords: 'чистка одинокие записи', access: { adminOnly: true } },
}

// Группы ниже «Каждый день». Пункт, уже стоящий в «Каждый день», из группы убирается — без дублей.
export const GROUPS = [
  { key: 'trade', name: 'Торги и распределение', icon: 'fa-trophy', hint: 'Откуда берутся рейсы и как делятся', items: ['bidding', 'distribution', 'calculator', 'approvals', 'routeCost'] },
  { key: 'trips', name: 'Рейсы и исполнители', icon: 'fa-truck', hint: 'Работа с заявкой от назначения до выгрузки', items: ['trips', 'executors', 'downtimes', 'claims'] },
  { key: 'money', name: 'Документы и деньги', icon: 'fa-file-invoice-dollar', hint: 'Реестры, оплаты и показатели', items: ['registry', 'finance'] },
  { key: 'refs', name: 'Справочники', icon: 'fa-address-book', hint: 'Машины, водители, перевозчики, заказчики', items: ['cars', 'trailers', 'drivers', 'companies', 'managers', 'customers', 'topClients'] },
  { key: 'analytics', name: 'Аналитика и ассистент', icon: 'fa-chart-pie', hint: 'Цифры, отчёты и AI', items: ['statGeneral', 'statDowntimes', 'statPersonal', 'statTm', 'ai', 'aiReports', 'aiKnowledge'] },
  { key: 'settings', name: 'Ставки и правила', icon: 'fa-sliders', hint: 'Пороги, ставки и формулы', items: ['rules', 'tripRates', 'baseRates', 'tradingRates', 'calcSettings', 'advanceBudgets', 'registrySettings', 'aiSettings'] },
  { key: 'admin', name: 'Администрирование', icon: 'fa-user-shield', hint: 'Пользователи, журналы, служебное', items: ['users', 'tmsLog', 'atiPublish', 'priceCheck', 'security', 'tmsTemplates', 'orphans'] },
]

// Внизу меню всегда: справка и уведомления (если не стоят выше).
export const FOOTER = ['knowledge', 'notifications']

// «Каждый день» по ролям — по порядку важности. Логист = роль «Менеджер».
export const DAILY = {
  'Менеджер': ['summary', 'trips', 'executors', 'downtimes', 'claims'],
  'Старший менеджер': ['summary', 'trips', 'distribution', 'approvals', 'executors', 'downtimes', 'claims'],
  'Руководитель отдела': ['summary', 'trips', 'claims', 'executors', 'downtimes', 'rules'],
  'Руководитель': ['summary', 'claims', 'finance', 'registry', 'trips', 'distribution'],
  'Админ': ['summary', 'claims', 'registry', 'trips', 'distribution', 'rules'],
  superadmin: ['summary', 'claims', 'registry', 'trips', 'distribution', 'rules'],
  default: ['summary', 'trips', 'claims'],
}

// Насколько часто роль пользуется пунктом (0–100) — стартовые веса из анализа истории рейсов.
// Дальше меню учится на самом человеке: личные переходы складываются с этими весами (menuLogic.mjs).
export const BASE_WEIGHTS = {
  'Менеджер': { trips: 100, summary: 90, executors: 70, downtimes: 45, claims: 40, notifications: 35, bidding: 15, distribution: 20, calculator: 15, drivers: 15, cars: 12, companies: 12 },
  'Старший менеджер': { trips: 100, summary: 90, distribution: 80, approvals: 70, executors: 60, downtimes: 40, claims: 40, bidding: 30, calculator: 25 },
  'Руководитель отдела': { summary: 100, trips: 80, claims: 70, executors: 50, downtimes: 50, rules: 40, statTm: 30, tmsLog: 25 },
  'Руководитель': { summary: 100, claims: 90, finance: 85, registry: 70, trips: 60, distribution: 50, statGeneral: 50, rules: 40, ai: 35 },
  default: { summary: 80, trips: 80, claims: 40, notifications: 30 },
}

export const ADMIN_ROLES = ['superadmin', 'Админ', 'Руководитель', 'Руководитель отдела']
